export const CSV_UPLOAD_LAYOUT_FLAG = 'CSV_UPLOAD_LAYOUT_FLAG';

export function csvUploadFlagForLayout(flag) {
  return {
    type: CSV_UPLOAD_LAYOUT_FLAG,
    flag,
  };
}
